var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"etoppagetext",style:({ margin: _vm.marginval !== undefined ? _vm.marginval : '0 0 70px 0' })},[_c('h1',[_vm._v(_vm._s(_vm.maintext))]),_c('p',[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }